// 語系判定規則（純函式、不碰瀏覽器全域）。core.js 執行時用它，vite.config.js 打包時也照同一份產生預載語言包的 inline script，兩邊不可分岔。
export const browserLangMap = {
  en: 'en',
  'en-US': 'en',
  zh: 'zh-Hans',
  'zh-CN': 'zh-Hans',
  'zh-HK': 'zh-Hant',
  'zh-SG': 'zh-Hant',
  'zh-TW': 'zh-Hant',
}

// 同舊版 lib/i18n/core.js：localStorage 有值就照用（即使不支援，畫面會顯示 key），沒有才看瀏覽器語系
export function detectLang(stored, navigatorLanguage, navigatorLanguages) {
  return stored ?? browserLangMap[navigatorLanguage ?? navigatorLanguages?.at(0)] ?? 'en'
}
